export default "__VITE_ASSET__78e0d64c__"